<template>
  <div v-loading="loading" class="rj-page-card">
    <div class="rj-page-card__title">
      订单合同
      <span v-if="isOverdueCustomer" style="margin-left: 12px; color: #f56c6c;">
        {{ form.integratorName }}被{{ form.distributorName }}标记为逾期客户，请注意是否需要线下沟通。
      </span>
    </div>
    <div class="rj-page-card__content">
      <el-form ref="form" :model="form" :rules="rules" class="baseInfoForm">
        <div class="rj-row">
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                订单日期：
              </div>
              <div class="rj-baseinfo__item">
                {{ form.createTime }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                电子商务合同编号：
              </div>
              <div class="rj-baseinfo__item">
                {{ form.contractNum }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                客户合同编号<span class="required">*</span>：
              </div>
              <div class="rj-baseinfo__item">
                <el-form-item prop="customerContractNum">
                  <el-input
                    v-model.trim="form.customerContractNum"
                    :disabled="true"
                    placeholder="客户合同编号"
                  />
                </el-form-item>
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div v-if="form.contractType!=='服务订单'" class="rj-baseinfo__label">
                供货单位(甲方)：
              </div>
              <div v-else class="rj-baseinfo__label">
                供货单位(乙方)：
              </div>
              <div class="rj-baseinfo__item">
                {{ form.supplyUnit }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                供货单位地址：
              </div>
              <div class="rj-baseinfo__item">
                {{ form.supplyAddress }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                供货单位电话：
              </div>
              <div class="rj-baseinfo__item">
                {{ form.supplyPhone }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div v-if="form.contractType!=='服务订单'" class="rj-baseinfo__label">
                订货单位(乙方)：
              </div>
              <div v-else class="rj-baseinfo__label">
                订货单位(甲方)：
              </div>
              <div class="rj-baseinfo__item">
                {{ form.orderUnit }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                订货单位电话：
              </div>
              <div class="rj-baseinfo__item">
                <el-form-item prop="name">
                  <el-input
                    v-model="form.orderUnitPhone"
                    placeholder="订货单位电话"
                  />
                </el-form-item>
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div v-if="isShowEsing" class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                采购类型：
              </div>
              <div class="rj-baseinfo__item">
                {{ form.purchaseType }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                最终客户：
              </div>
              <div class="rj-baseinfo__item">
                {{ form.finalCustomer }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                订单分类：
              </div>
              <div class="rj-baseinfo__item">
                {{ form.contractType }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                客户签约类型：
              </div>
              <div class="rj-baseinfo__item">
                {{ form.customerContractType }}
              </div>
            </div>
          </div>
          <div v-if="isShowEsing" class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                业务类型：
              </div>
              <div class="rj-baseinfo__item">
                {{ form.projectType }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                首级集成商：
              </div>
              <div v-if="form.integratorName" class="rj-baseinfo__item">
                {{ form.integratorName }}
              </div>
              <div v-else class="rj-baseinfo__item">
                无
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                首级集成商类型：
              </div>
              <div v-if="form.integratorType" class="rj-baseinfo__item">
                {{ form.integratorType }}
              </div>
              <div v-else class="rj-baseinfo__item">
                无
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                区域：
              </div>
              <div class="rj-baseinfo__item">
                {{ form.regionName }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                外销姓名：
              </div>
              <div class="rj-baseinfo__item">
                {{ form.salesManName }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                部门：
              </div>
              <div class="rj-baseinfo__item">
                {{ form.departmentName }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                区域商务专员：
              </div>
              <div class="rj-baseinfo__item">
                {{ form.regionBusinessCommissioner }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                售前姓名：
              </div>
              <div class="rj-baseinfo__item">
                {{ form.preSalesName }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                项目名称：
              </div>
              <div class="rj-baseinfo__item">
                {{ form.projectName }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                服务主体编码：
              </div>
              <div class="rj-baseinfo__item">
                {{ form.serviceSubjectCode }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                计量计点：
              </div>
              <!--<div class="rj-baseinfo__item">{{ $store.dispatch('enumeration/getmeteringPoint',form.meteringPoint) }}</div>-->
              <div class="rj-baseinfo__item">
                {{
                  $store.getters["enumeration/getmeteringPoint"](
                    form.meteringPoint
                  )
                }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                是否体现嵌入式产品软件：
              </div>
              <div class="rj-baseinfo__item">
                {{
                  $store.getters["enumeration/getisEmbeddedSoftware"](
                    form.isEmbeddedSoftware
                  )
                }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                服务主体名称：
              </div>
              <div class="rj-baseinfo__item">
                {{ form.serviceSubjectName }}
              </div>
            </div>
          </div>
          <div v-show="!isShowEsing" class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                A类产品服务商：
              </div>
              <div
                v-if="form.productServiceProviderA"
                class="rj-baseinfo__item"
              >
                {{ form.productServiceProviderA }}
              </div>
              <div v-else class="rj-baseinfo__item">
                无
              </div>
            </div>
          </div>
          <div v-show="!isShowEsing" class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                B类产品服务商：
              </div>
              <div
                v-if="form.productServiceProviderB"
                class="rj-baseinfo__item"
              >
                {{ form.productServiceProviderB }}
              </div>
              <div v-else class="rj-baseinfo__item">
                无
              </div>
            </div>
          </div>
          <div v-show="!isShowEsing" class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                C类产品服务商：
              </div>
              <div
                v-if="form.productServiceProviderC"
                class="rj-baseinfo__item"
              >
                {{ form.productServiceProviderC }}
              </div>
              <div v-else class="rj-baseinfo__item">
                无
              </div>
            </div>
          </div>
          <div v-if="form.manufactureRefurbished" class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                是否官翻机：
              </div>
              <div class="rj-baseinfo__item">
                {{ form.manufactureRefurbished ? "是" : "否" }}
              </div>
            </div>
          </div>
        </div>
        <div class="rj-row">
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                区域商务专员意见信息：
              </div>
              <div class="rj-baseinfo__item">
                {{ form.regionBusinessCommissionerOpinion }}
              </div>
            </div>
          </div>
        </div>
        <div class="rj-row">
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                现销或赊销<span class="required">*</span>：
              </div>
              <div class="rj-baseinfo__item">
                <!--<el-form-item prop="name">-->
                <!--<el-radio-group v-model="form.salesType">-->
                <!--<el-radio :label="option.code" v-for="option in salesType" :key="option.code">{{ option.name }}</el-radio>-->
                <!--</el-radio-group>-->
                <!--</el-form-item>-->
                {{ $store.getters["enumeration/getsalesType"](form.salesType) }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                账期：
              </div>
              <div class="rj-baseinfo__item force-line-break">
                {{ form.accountPeriod }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                发货方式<span class="required">*</span>：
              </div>
              <div class="rj-baseinfo__item">
                <el-form-item prop="shipType">
                  <el-radio-group v-model="form.shipType">
                    <el-radio
                      v-for="option in shipType"
                      :key="option.code"
                      :label="option.code"
                    >
                      {{ option.name }}
                    </el-radio>
                  </el-radio-group>
                </el-form-item>
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                齐套通知打款邮箱<span class="required">*</span>：
              </div>
              <div class="rj-baseinfo__item">
                <el-form-item prop="setNoticeMail">
                  <!--<el-input v-model.trim="form.setNoticeMail" placeholder="请输入邮箱" />-->
                  <el-autocomplete
                    v-model="form.setNoticeMail"
                    class="inline-input"
                    :fetch-suggestions="querySearch"
                    placeholder="请输入齐套通知打款邮箱"
                    @select="handleSelect"
                  >
                    <template slot-scope="{ item }">
                      <div class="name">
                        {{ item.setNoticeMail }}
                      </div>
                    </template>
                  </el-autocomplete>
                </el-form-item>
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                授权邮箱：
              </div>
              <div class="rj-baseinfo__item">
                <el-form-item prop="authorizationEmail">
                  <el-input
                    v-model.trim="form.authorizationEmail"
                    placeholder="请输入授权邮箱"
                  />
                </el-form-item>
              </div>
            </div>
          </div>
        </div>
        <!-- 临时加入的电票通知邮箱 -->
        <div v-if="form.displayedInvoiceEmail" class="rj-row">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              电票下载邮箱：
            </div>
            <div class="rj-baseinfo__item">
              <el-form-item prop="invoiceEmail">
                <span style="margin-right: 20px">{{ form.invoiceEmail || '-' }}</span>
                <el-button type="primary" @click="showDialogMethods">
                  选择电票邮箱
                </el-button>
                <email-form-dialog ref="addEmailRefs" :visible.sync="showDialog" @submit="handleFormSubmit" />
              </el-form-item>
            </div>
          </div>
        </div>
        <div class="rj-row">
          <div v-show="!isShowEsing" class="rj-col-1">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                是否使用返利<span class="required">*</span>：
              </div>
              <div class="rj-baseinfo__item">
                <el-form-item style="display: inline-block" prop="isRebate">
                  <el-radio-group
                    v-model="form.isRebate"
                    @change="changisRebate"
                  >
                    <el-radio
                      :label="true"
                      :disabled="isRebatedisabled"
                    >
                      是
                    </el-radio>
                    <el-radio
                      :label="false"
                      :disabled="isRebatedisabled"
                    >
                      否
                    </el-radio>
                  </el-radio-group>
                </el-form-item>
                <template v-if="form.isRebate">
                  使用金额: {{ form.rebateAmount }} 元
                  <!-- eslint-disable-next-line vue/require-component-is -->
                  <component
                    v-bind="dialogNode"
                    @chooesSuccess="chooseRebateSuccess"
                  />
                </template>
              </div>
            </div>
          </div>
          <div class="rj-col-1">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                收款银行<span class="required">*</span>：
              </div>
              <div class="rj-baseinfo__item">
                <el-form-item prop="paymentBankId">
                  <el-radio-group v-model="form.paymentBankId">
                    <el-radio
                      v-for="bank in form.bankInfos"
                      :key="bank.openBankId"
                      :label="bank.openBankId"
                    >
                      {{ bank.openBankName }}
                    </el-radio>
                  </el-radio-group>
                </el-form-item>
              </div>
            </div>
          </div>
          <div class="rj-col-1">
            <el-form-item label="补充条款:">
              <el-input
                v-model.trim="form.additionalTerms"
                type="textarea"
                :rows="3"
                placeholder="请输入补充条款内容"
                maxlength="200"
                show-word-limit
              />
            </el-form-item>
          </div>
          <div class="rj-col-1">
            <el-form-item label="备注说明:" style="margin-top: 10px">
              <el-input
                v-model.trim="form.remarks"
                type="textarea"
                :rows="3"
                placeholder="请输入备注说明内容"
                maxlength="200"
                show-word-limit
              />
            </el-form-item>
          </div>
          <div class="rj-col-1">
            <el-form-item prop="deliverRemark" label="发货备注说明:">
              <el-input
                v-model.trim="form.deliverRemark"
                type="textarea"
                :rows="3"
                placeholder="请输入发货备注说明"
                maxlength="200"
                show-word-limit
              />
            </el-form-item>
          </div>
          <div class="rj-col-1">
            <el-form-item prop="invoiceRemark" label="开票备注说明:">
              <el-input
                v-model.trim="form.invoiceRemark"
                type="textarea"
                :rows="3"
                placeholder="请输入开票备注说明"
                maxlength="200"
                show-word-limit
              />
            </el-form-item>
          </div>
        </div>
      </el-form>
    </div>
  </div>
</template>
<script type="es6">
import { mapState } from 'vuex';
import { MathMulti, getNum } from '@/libs/util';
import { getNoticeSendMailList, getEditRebateUsedList, getRebateSummaryAgentInfo } from '@/API/index.js';
import rebateUse from '../rabateUse';
import rebateUsedList from '../rebateUsedList';
import Big from 'big.js';
import EmailFormDialog from './addEmail.vue';

/* eslint-disable */
export default {
  data () {
    var checkShipType = (rule, value, callback) => {
      if (this.form.shipType === 0) {
        callback(new Error('请选择发货方式'));
      } else {
        callback();
      }
    };
    var validateEmail = (rule, value, callback) => {
      const mailReg =  /^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.|\-]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,4}$/;
      if (!value) {
        callback(new Error('请输入齐套通知打款邮箱'));
      } else {
        if (this.form.setNoticeMail && this.form.setNoticeMail.length > 100) {
          callback(new Error('输入字符不能超过100'));
        } else if (!mailReg.test(value)) {
          callback(new Error('请输入正确的邮箱格式'));
        } else {
          callback();
        }
      }

    };
    var validateEmailAuthorization = (rule, value, callback) => {
      const mailReg = /^([a-zA-Z0-9]+[_|.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[.|-]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,4}$/;
      if (!value) {
        callback();
      } else {
        if (this.form.authorizationEmail && this.form.authorizationEmail.length > 100) {
          callback(new Error('输入字符不能超过100'));
        } else if (!mailReg.test(value)) {
          callback(new Error('请输入正确的邮箱格式'));
        } else {
          callback();
        }
      }
    };
    return {
      showDialog: false,
      rules: {
        shipType: [
          { required: true, message: '请选择发货方式', trigger: 'change' },
          { validator: checkShipType, message: '请选择发货方式', trigger: 'change' }
        ],
        customerContractNum: [
          { required: true, message: '请输入客户合同编号', trigger: 'blur' }
        ],
        // orderUnitPhone: [
        //   { required: true, message: '请输入订货单位电话', trigger: 'blur' }
        // ],
        salesType: [
          { required: true, message: '请选择', trigger: 'change' }
        ],
        isRebate: [
          { required: true, message: '请选择是否使用返利', trigger: 'change' }
        ],
        paymentBankId: [
          { required: true, message: '请选择收款银行', trigger: 'change' }
        ],
        authorizationEmail: [
          { validator: validateEmailAuthorization, trigger: 'change' }
        ],
        setNoticeMail: [
          { validator: validateEmail, trigger: 'change' }
        ]
      },
      loading: false,
      addProducts:false,
      dialogNode: {
        is: '',
        allow: this.allowUserRate,
        availableRebateAmount: 0,
        rebateUsedList: [],
        householdProducts: this.form.householdProducts,
        customerContractType: this.form.customerContractType
      }
    };
  },
  props: {
    form: {
      type: Object,
      default: () => {
        return { bankInfos: [], contractProductInfos: []};
      }
    },
    isOverdueCustomer: {
      type: Boolean,
      default: false
    },
    orderSales: {
      type: [Number, String],
      default: 0
    }
  },
  components: {
    EmailFormDialog,
    rebateUse,
    rebateUsedList
  },
  computed: {
    ...mapState({
      salesType: state => state.enumeration.salesType,
      shipType: state => state.enumeration.shipType
    }),
    getRetorgServeMoney(){
      return this.form.contractProductInfos.filter(v => v.productCategoryName === '后返服务').reduce((pre, cur) => {
        return Big(pre).plus(getNum(cur.orderAmount)).toNumber()
      }, 0)
    },
    allowUserRate () {
      let str = Big(getNum(this.form.orderSales)).minus(this.getRetorgServeMoney).times(0.3).toString().match(/^\d+(?:\.\d{0,2})?/)
      return Number(str)
    },
    isShowEsing () {
      // 如果是新ECP && 是服务订单就展示
      return this.form.sources === 'NEW-ECP' && this.form.contractType === '服务订单';
    },
    isRebatedisabled () {
      return this.form.manufactureRefurbished || this.form.freightContract || this.form.contractType ==='服务订单'
    }
  },
  methods: {
    // 打开选择电票邮箱弹窗
    showDialogMethods(){
      this.showDialog = true;
      let setEmailData = this.form.invoiceEmail || ''
      this.$refs.addEmailRefs.setEditEmailData(setEmailData)
    },
    // 电票邮箱确定后的回调函数
    handleFormSubmit (data) {
      this.form.invoiceEmail = data.keysString;
      this.showDialog = false;
    },
    async validate () {
      return new Promise((resolve, reject) => {
        this.$refs.form.validate().then(() => {
          if (!this.form.receiptAddressId) {
            this.$notify.error({
              message: '请选择收货地址'
            });
            resolve(false);
          }
          resolve(this.form);
        }).catch(() => {
          resolve(false);
          const container = document.getElementById('routerScroll');
          const scroll = container && container.getElementsByClassName('el-scrollbar__wrap')[0];
          if (scroll && scroll.scrollTo) scroll.scrollTo(0, 0);
        });
      });
    },
    changisRebate (val) {
      if (!val) {
        this.form.rebateAmount = 0;
        this.dialogNode.rebateUsedList = []
      }
    },
    chooseRebateSuccess (val) {
      //赋值过程toFixed();
      this.form.rebateAmount = val.total;
      this.dialogNode.rebateUsedList = val.list;
    },
    changrebateAmount (val) {
      // 使用返利值变化
      let vals = val;
      if (MathMulti(this.form.orderSales, 0.3) < vals) {
        this.$nextTick(() => {
          this.form.rebateAmount = MathMulti(this.form.orderSales, 0.3);
          if (this.form.rebateAmount > this.form.remainderRebateAmount) {
            this.form.rebateAmount = this.form.remainderRebateAmount;
          }
        });
        this.$notify.warning('不能超过订单金额的30%');
      } else if (vals > this.form.remainderRebateAmount) {
        this.$nextTick(() => {
          this.form.rebateAmount = this.form.remainderRebateAmount;
        });
        this.$notify.warning('不能大于剩余返利可用金额');
      }
      this.$emit('changRebateAmount', this.form.rebateAmount);
    },
    querySearch (queryString, cb) {
      getNoticeSendMailList().then((res) => {
        let json = res.data;
        if (json.status === '200') {
          let results = queryString ? json.data.filter(this.createFilter(queryString)) : json.data;
          cb(results);
        }
      }).catch((res) => {

      });
    },
    createFilter (queryString) {
      return (restaurant) => {
        return (restaurant.setNoticeMail.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },
    handleSelect (val) {
      this.form.setNoticeMail = val.setNoticeMail;
    },
    getEditRebateUsedList () {
      getEditRebateUsedList({ contractNum: this.form.contractNum }).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          if (json.data.length) {
            this.dialogNode.rebateUsedList = json.data;
            this.dialogNode.is = 'rebate-used-list';
          } else {
            this.dialogNode.is = 'rebate-use';
          }
          this.dialogNode.allow = this.allowUserRate;
        }
      }).catch(() => {

      });
      getRebateSummaryAgentInfo({ contractNum: this.form.contractNum }).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.dialogNode.availableRebateAmount = json.data.availableAmount;
        }
      }).catch(() => {

      });
    },

  },
  mounted () {
  },
  watch: {
    orderSales (newQuestion) {
      this.form.orderSales = newQuestion;
    },
    'form.customerContractType' (newVal) {
     this.dialogNode.customerContractType = newVal;
    },
    'form.householdProducts' (newVal) {
     this.dialogNode.householdProducts = newVal;
    },
  }
};
</script>
<style lang="scss" scoped>
.baseInfoForm {
  .el-form-item--mini.el-form-item {
    margin-bottom: 0;
  }
}
.required {
  color: red;
  margin-left: 3px;
}
</style>
<style lang="scss">
.baseInfoForm {
  .el-form-item__error {
    position: relative;
  }
  .el-autocomplete {
    width: 100%;
  }
}
</style>
